import React from 'react';
import {
  Flex,
  Stack,
  Text,
  HStack,
  Badge,
  Icon,
  Card,
  CardHeader,
  CardBody,
  Heading,
  Spinner,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiActivity } from 'react-icons/fi';

/**
 * ActivityFeed - Component to display recent activity
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isLoading - Loading state
 * @param {Array} props.activities - Activities data array
 */
const ActivityFeed = ({ isLoading, activities = [] }) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  
  // Map activity type to color scheme
  const getColorScheme = (type) => {
    const colorMap = {
      'Nova Categoria': 'green',
      'Novo Admin': 'blue',
      'Atualização': 'purple',
      'Alerta': 'red',
      'Financeiro': 'orange',
      'Usuário': 'teal',
      'Prestador': 'cyan',
      'Sistema': 'yellow'
    };
    
    return colorMap[type] || 'gray';
  };
  
  return (
    <Card bg={cardBg} boxShadow="md">
      <CardHeader pb={0}>
        <Flex align="center">
          <Icon as={FiActivity} mr={2} />
          <Heading size="md">Atividades Recentes</Heading>
        </Flex>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <Flex justify="center" py={6}>
            <Spinner />
          </Flex>
        ) : activities && activities.length > 0 ? (
          <Stack spacing={3}>
            {activities.map((activity, index) => (
              <Flex key={index} justify="space-between" align="center" p={2} bg="gray.50" borderRadius="md">
                <HStack>
                  <Badge colorScheme={getColorScheme(activity.type)}>{activity.type}</Badge>
                  <Text>{activity.description}</Text>
                </HStack>
                <Text fontSize="sm" color="gray.500">{activity.time}</Text>
              </Flex>
            ))}
          </Stack>
        ) : (
          <Stack spacing={3}>
            <Flex justify="space-between" align="center" p={2} bg="gray.50" borderRadius="md">
              <HStack>
                <Badge colorScheme="green">Nova Categoria</Badge>
                <Text>Instalação de Ar Condicionado</Text>
              </HStack>
              <Text fontSize="sm" color="gray.500">2 horas atrás</Text>
            </Flex>
            <Flex justify="space-between" align="center" p={2} bg="gray.50" borderRadius="md">
              <HStack>
                <Badge colorScheme="blue">Novo Admin</Badge>
                <Text>Carlos Silva adicionado como Suporte</Text>
              </HStack>
              <Text fontSize="sm" color="gray.500">5 horas atrás</Text>
            </Flex>
            <Flex justify="space-between" align="center" p={2} bg="gray.50" borderRadius="md">
              <HStack>
                <Badge colorScheme="purple">Atualização</Badge>
                <Text>Nova versão do aplicativo publicada</Text>
              </HStack>
              <Text fontSize="sm" color="gray.500">Ontem</Text>
            </Flex>
            <Flex justify="space-between" align="center" p={2} bg="gray.50" borderRadius="md">
              <HStack>
                <Badge colorScheme="red">Alerta</Badge>
                <Text>Pico de tráfego detectado</Text>
              </HStack>
              <Text fontSize="sm" color="gray.500">Ontem</Text>
            </Flex>
            <Flex justify="space-between" align="center" p={2} bg="gray.50" borderRadius="md">
              <HStack>
                <Badge colorScheme="orange">Financeiro</Badge>
                <Text>Relatório mensal gerado</Text>
              </HStack>
              <Text fontSize="sm" color="gray.500">2 dias atrás</Text>
            </Flex>
          </Stack>
        )}
      </CardBody>
    </Card>
  );
};

export default ActivityFeed;